"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@reportdata/reportingyear/success",
  ERROR: "@@reportdata/reportingyear/error",
  RESET: "@@reportdata/reportingyear/reset",
  REPORT_NOT_EXIST_LIST: "@@reportdata/reportingyear/report-not-exist",
  FIND_CURRENT_FISCAL_YEAR_BY_ORGID: "@@reportdata/reportingyear/find-current-fiscal-year-by-orgid",
  REPORTING_YEAR_LIST: "@@reportdata/reportingyear/list",
  REPORTING_YEAR_LIST_DELETE: "@@reportdata/reportingyear/delete-list",
  REPORTING_YEAR_ADD: "@@reportdata/reportingyear/add"
};
exports.actionTypes = actionTypes;